export default "__VITE_ASSET__DewanYjd__"